module.exports = __webpack_public_path__ + "static/media/yesterdayBG.83350701.png";